import React from 'react'

 const Viewcustomer = () => {
  return (
    <div>viewcustomer</div>
  )
}
export default Viewcustomer;
